var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('iframe',{attrs:{"width":"100%","height":"515","src":"https://www.youtube.com/embed/K7VQZ_W8BxI","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }